export default __webpack_public_path__ + "static/media/Thief's Jerkin of the Tenth Court.6882ed18.jpg";